/**
 * Whether the Release Notes surface is published to users (ADO #519).
 *
 * Set to `false` for the 2026-09 release. The page at `/help/release-notes` and
 * its content are deliberately left intact and the route still resolves — only
 * the two entry points that advertise it are hidden:
 *
 *   1. the "Release notes" link in the Knowledge Center top bar, and
 *   2. the "What's new" strip on the Help Center home page.
 *
 * WHY, from Krish on the ticket: nobody is reading the page yet (no paying
 * customers), and at our current cadence — 2.0.0, 2.0.1 and 2.0.2 all shipped
 * inside one day — a page that tries to itemise every release either becomes
 * noise or goes stale. A stale release-notes page reads worse than not having
 * one, because it signals the product isn't being maintained.
 *
 * That risk is not hypothetical: the generated `releaseNotes.ts` is built from
 * git tags, the newest tag is v1.3.8 (2026-08-29), and the app is on 2.0.2 — so
 * both entry points currently announce a version three releases behind. Hiding
 * them removes the wrong claim without touching the page or its history.
 *
 * TO RE-ENABLE: flip this to `true`. Nothing else was removed, so the surface
 * comes back exactly as it was — but cut the missing tags and re-run
 * `pnpm release-notes` first, or it will return still showing v1.3.8 as latest.
 */
export const RELEASE_NOTES_PUBLISHED = false;
